"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFoundation = require("react-foundation");

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

var _lodash3 = _interopRequireDefault(require("lodash.isempty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

var _clientAwsS = require("@devsta/client-aws-s3");

var _AssignUserModal = _interopRequireDefault(require("../../../common/components/AssignUserModal"));

var _InviteUsersModal = _interopRequireDefault(require("../../../common/components/InviteUsersModal"));

var _UsersList = _interopRequireDefault(require("./UsersList"));

var _Statistic = _interopRequireDefault(require("./Statistic"));

var _Clients = _interopRequireDefault(require("./Clients"));

var _utils = require("../utils");

require("../styles/_team.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MODAL = {
  ADD_USER: 'add-users'
};
var SORT_ORDER = ['ADMIN', 'USER'];

var Team = /*#__PURE__*/function (_Component) {
  _inherits(Team, _Component);

  function Team(props) {
    var _this;

    _classCallCheck(this, Team);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Team).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleRoleChange", (0, _memoizeOne.default)(function (teamMembershipId) {
      return (/*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
            var value, updateTeamMembership, teamMemberships, _ref3, userListError, data, role, updatedMemberships;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    value = _ref2.value;
                    updateTeamMembership = _this.props.updateTeamMembership;
                    teamMemberships = _this.state.teamMemberships;
                    _context.next = 5;
                    return updateTeamMembership({
                      teamMembershipId: teamMembershipId,
                      input: {
                        roleId: value
                      }
                    });

                  case 5:
                    _ref3 = _context.sent;
                    userListError = _ref3.userListError;
                    data = _ref3.data;

                    if (!userListError) {
                      _context.next = 10;
                      break;
                    }

                    return _context.abrupt("return");

                  case 10:
                    role = data.updateTeamMembership.role;
                    updatedMemberships = teamMemberships.map(function (membership) {
                      if (membership.teamMembershipId !== teamMembershipId) {
                        return membership;
                      }

                      return _objectSpread({}, membership, {
                        role: role
                      });
                    });

                    _this.setState({
                      teamMemberships: updatedMemberships
                    });

                  case 13:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()
      );
    }));

    _defineProperty(_assertThisInitialized(_this), "handleFiltersChange", (0, _lodash.default)(function (_ref4) {
      var searchTerm = _ref4.searchTerm;

      _this.fetchMemberships({
        searchTerm: searchTerm
      });
    }, 300));

    _defineProperty(_assertThisInitialized(_this), "openModal", (0, _memoizeOne.default)(function (modalName) {
      return function () {
        _this.setState({
          openedModalName: modalName
        }, function () {
          if (document.body) {
            document.body.classList.add('no-scroll');
          }
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "closeModal", (0, _memoizeOne.default)(function (modalName) {
      return function () {
        var openedModalName = _this.state.openedModalName;

        if (modalName !== openedModalName) {
          return;
        }

        _this.setState({
          openedModalName: ''
        }, function () {
          if (document.body) {
            document.body.classList.remove('no-scroll');
          }
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "getActionOptions", (0, _memoizeOne.default)(function () {
      var orgPermissions = _this.props.orgPermissions;
      var actionOptions = [{
        action: _this.deleteTeam,
        label: 'Delete Team',
        isRed: true,
        requiredPermission: ['MANAGE_TEAM', 'MANAGE_ORGANISATION']
      }];
      return actionOptions.filter(function (_ref5) {
        var requiredPermission = _ref5.requiredPermission;
        return !requiredPermission || requiredPermission.every(function (permission) {
          return (0, _commonReact.hasPermission)(permission, orgPermissions);
        });
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "fetchData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Promise.all([_this.fetchTeam(), _this.fetchRoles(), _this.fetchOrganisations()]);

            case 2:
              _context2.next = 4;
              return _this.fetchMemberships();

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "deleteTeam", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var teamId, _this$props, history, deleteTeam, _ref8, data, error;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              teamId = _this.state.teamInfo.teamId;
              _this$props = _this.props, history = _this$props.history, deleteTeam = _this$props.deleteTeam;
              _context3.next = 4;
              return deleteTeam({
                teamId: teamId
              });

            case 4:
              _ref8 = _context3.sent;
              data = _ref8.data;
              error = _ref8.error;

              if (!(error || !data || !data.deleteTeam)) {
                _context3.next = 9;
                break;
              }

              return _context3.abrupt("return");

            case 9:
              history.goBack();

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchTeam", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _this$props2, teamId, getTeam, _ref10, data, error, teamInfo;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props2 = _this.props, teamId = _this$props2.teamId, getTeam = _this$props2.getTeam;
              _context4.prev = 1;
              _context4.next = 4;
              return getTeam(teamId);

            case 4:
              _ref10 = _context4.sent;
              data = _ref10.data;
              error = _ref10.error;

              if (!(error || !data)) {
                _context4.next = 9;
                break;
              }

              return _context4.abrupt("return", void _this.setState({
                error: true
              }));

            case 9:
              teamInfo = _objectSpread({}, data.getTeam);

              _this.setState({
                teamInfo: teamInfo
              });

              _context4.next = 16;
              break;

            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](1);

              _this.setState({
                error: true
              });

            case 16:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 13]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchRoles", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _this$props3, organisationId, getRoles, _ref12, data, error;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this$props3 = _this.props, organisationId = _this$props3.organisationId, getRoles = _this$props3.getRoles;
              _context5.prev = 1;
              _context5.next = 4;
              return getRoles(organisationId);

            case 4:
              _ref12 = _context5.sent;
              data = _ref12.data;
              error = _ref12.error;

              if (!(error || !data)) {
                _context5.next = 9;
                break;
              }

              return _context5.abrupt("return", void _this.setState({
                error: true
              }));

            case 9:
              _this.setState({
                teamRoles: data.TEAM,
                orgRoles: data.ORGANISATION
              });

              _context5.next = 15;
              break;

            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](1);

              _this.setState({
                error: true
              });

            case 15:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 12]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchOrganisations", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var _this$props4, teamId, getOrganisationsByEditingTeamId, apolloClient, organisationId, _ref14, data, error, organisationsWithImage, organisations;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _this$props4 = _this.props, teamId = _this$props4.teamId, getOrganisationsByEditingTeamId = _this$props4.getOrganisationsByEditingTeamId, apolloClient = _this$props4.apolloClient, organisationId = _this$props4.organisationId;
              _context7.prev = 1;
              _context7.next = 4;
              return getOrganisationsByEditingTeamId(teamId);

            case 4:
              _ref14 = _context7.sent;
              data = _ref14.data;
              error = _ref14.error;

              if (!(error || !data)) {
                _context7.next = 9;
                break;
              }

              return _context7.abrupt("return", void _this.setState({
                error: true
              }));

            case 9:
              _context7.next = 11;
              return (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                apiClient: apolloClient,
                dataArray: data.getOrganisationsByEditingTeamId,
                substitutedKeys: ['imageUrl']
              });

            case 11:
              organisationsWithImage = _context7.sent;
              _context7.next = 14;
              return Promise.all(organisationsWithImage.map( /*#__PURE__*/function () {
                var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(orgDetails) {
                  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.t0 = _objectSpread;
                          _context6.t1 = {};
                          _context6.t2 = orgDetails;
                          _context6.next = 5;
                          return (0, _clientAwsS.replaceBucketKeysWithUrls)({
                            apiClient: apolloClient,
                            data: _objectSpread({}, orgDetails.accountManager, {
                              organisationId: organisationId
                            }),
                            substitutedKeys: ['imageUrl']
                          });

                        case 5:
                          _context6.t3 = _context6.sent;
                          _context6.t4 = {
                            accountManager: _context6.t3
                          };
                          return _context6.abrupt("return", (0, _context6.t0)(_context6.t1, _context6.t2, _context6.t4));

                        case 8:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }));

                return function (_x2) {
                  return _ref15.apply(this, arguments);
                };
              }()));

            case 14:
              organisations = _context7.sent;

              _this.setState({
                organisations: organisations
              });

              _context7.next = 21;
              break;

            case 18:
              _context7.prev = 18;
              _context7.t0 = _context7["catch"](1);

              _this.setState({
                error: true
              });

            case 21:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[1, 18]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchMemberships", /*#__PURE__*/function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _ref17,
            searchTerm,
            _this$props5,
            apolloClient,
            searchTeamMemberships,
            organisationId,
            orgRoles,
            _ref18,
            data,
            error,
            allTeamMemberships,
            memberships,
            orgAdmins,
            teamMembers,
            teamMemberships,
            _args8 = arguments;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _ref17 = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {}, searchTerm = _ref17.searchTerm;
                _this$props5 = _this.props, apolloClient = _this$props5.apolloClient, searchTeamMemberships = _this$props5.searchTeamMemberships, organisationId = _this$props5.organisationId;
                orgRoles = _this.state.orgRoles;

                _this.setState({
                  userListLoading: true
                });

                _context8.next = 6;
                return searchTeamMemberships({
                  searchTerm: searchTerm ? searchTerm.toLowerCase() : ''
                });

              case 6:
                _ref18 = _context8.sent;
                data = _ref18.data;
                error = _ref18.error;

                if (!(error || !data)) {
                  _context8.next = 11;
                  break;
                }

                return _context8.abrupt("return", void _this.setState({
                  userListError: true
                }));

              case 11:
                _context8.prev = 11;
                allTeamMemberships = (0, _utils.createTeamMemberships)(data.searchTeamMemberships, orgRoles, organisationId);
                _context8.next = 15;
                return (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                  apiClient: apolloClient,
                  dataArray: allTeamMemberships,
                  substitutedKeys: [{
                    key: 'user',
                    subKeys: ['imageUrl']
                  }],
                  organisationId: organisationId
                });

              case 15:
                memberships = _context8.sent;
                orgAdmins = memberships.filter(function (member) {
                  return member.isOrgAdmin;
                });
                teamMembers = memberships.filter(function (member) {
                  return !member.isOrgAdmin;
                }); // Sort team admin

                teamMembers.sort(function (prev, next) {
                  return SORT_ORDER.indexOf(prev.role.name) - SORT_ORDER.indexOf(next.role.name);
                }); // Always keep org Admins at the top

                teamMemberships = [].concat(_toConsumableArray(orgAdmins), _toConsumableArray(teamMembers)); // Count number of editors from organisation membership apart from filters

                if (!searchTerm) {
                  _this.setState({
                    editors: memberships.filter(function (teamMember) {
                      return teamMember.isOrgEditor;
                    })
                  });
                }

                _this.setState({
                  teamMemberships: teamMemberships,
                  userListLoading: false
                });

                _context8.next = 27;
                break;

              case 24:
                _context8.prev = 24;
                _context8.t0 = _context8["catch"](11);

                _this.setState({
                  userListLoading: false,
                  userListError: true
                });

              case 27:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[11, 24]]);
      }));

      return function () {
        return _ref16.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "renderStatistics", function () {
      var _this$state = _this.state,
          teamInfo = _this$state.teamInfo,
          organisations = _this$state.organisations,
          editors = _this$state.editors;
      var items = [{
        value: organisations.length,
        text: 'client'
      }, {
        value: editors ? editors.length : 0,
        text: 'video editor'
      }];
      var nonEditingStats = [{
        value: (0, _lodash2.default)(teamInfo, 'members.length', 0),
        text: 'user'
      }];
      var itemsToMap = !teamInfo || teamInfo.type !== 'EDITING' ? nonEditingStats : items;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('statistics', {
          'multi-column': itemsToMap.length > 1
        })
      }, itemsToMap.map(function (item, index) {
        var key = "".concat(index, "-").concat(item.text);
        return _react.default.createElement(_Statistic.default, _extends({
          key: key
        }, item));
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onInviteUserToTeam", function () {
      _this.setState({
        inviteUserModalVisible: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onInviteUsersModalClose", function () {
      _this.setState({
        inviteUserModalVisible: false,
        openedModalName: MODAL.ADD_USER
      });
    });

    _this.state = {
      openedModalName: '',
      teamInfo: {},
      teamRoles: [],
      orgRoles: [],
      organisations: [],
      teamMemberships: [],
      editors: [],
      error: false,
      userListError: false,
      userListLoading: false,
      inviteUserModalVisible: false
    };
    return _this;
  }

  _createClass(Team, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          history = _this$props6.history,
          orgPermissions = _this$props6.orgPermissions,
          organisationName = _this$props6.organisationName,
          teamId = _this$props6.teamId;
      var _this$state2 = this.state,
          teamInfo = _this$state2.teamInfo,
          organisations = _this$state2.organisations,
          openedModalName = _this$state2.openedModalName,
          teamRoles = _this$state2.teamRoles,
          orgRoles = _this$state2.orgRoles,
          error = _this$state2.error,
          teamMemberships = _this$state2.teamMemberships,
          userListError = _this$state2.userListError,
          userListLoading = _this$state2.userListLoading,
          inviteUserModalVisible = _this$state2.inviteUserModalVisible;
      var addUserModalVisible = openedModalName === MODAL.ADD_USER;

      if (error) {
        return _react.default.createElement(_commonReact.Error, null);
      }

      var selectedTeam = {
        label: teamInfo.name,
        value: teamInfo.teamId
      };
      var hasManagePermission = (0, _commonReact.hasPermission)('MANAGE_TEAM', orgPermissions) && (0, _commonReact.hasPermission)('MANAGE_ORGANISATION', orgPermissions);
      return _react.default.createElement("div", {
        className: "team page"
      }, addUserModalVisible && _react.default.createElement(_AssignUserModal.default, {
        visible: addUserModalVisible,
        onClose: this.closeModal(MODAL.ADD_USER),
        teamId: teamInfo.teamId,
        onSave: this.fetchMemberships,
        teamRoles: teamRoles,
        hasManagePermission: hasManagePermission,
        onInviteUserToTeam: this.onInviteUserToTeam
      }), inviteUserModalVisible && _react.default.createElement(_InviteUsersModal.default, {
        visible: inviteUserModalVisible,
        onClose: this.onInviteUsersModalClose,
        onInvited: this.fetchData,
        organisationRoles: orgRoles,
        selectedTeam: selectedTeam
      }), _react.default.createElement(_uiKit.PageHeader, {
        actionBtnText: "Add Users",
        title: teamInfo.name,
        subtitle: organisationName,
        actionPopupOptions: this.getActionOptions(),
        actionPopupBackgroundColor: "parthenon",
        actionBtnOnClick: this.openModal(MODAL.ADD_USER)
      }), _react.default.createElement(_reactFoundation.Column, null, _react.default.createElement("div", {
        className: "team-information"
      }, _react.default.createElement("span", {
        className: "team-description"
      }, teamInfo.description), this.renderStatistics()), _react.default.createElement("hr", null), !(0, _lodash3.default)(organisations) && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Clients.default, {
        items: organisations
      }), _react.default.createElement("hr", null)), _react.default.createElement(_UsersList.default, {
        history: history,
        teamRoles: teamRoles,
        teamName: teamInfo.name,
        teamId: teamId,
        orgPermissions: orgPermissions,
        teamMemberships: teamMemberships,
        userListError: userListError,
        userListLoading: userListLoading,
        onMembershipDeleted: this.fetchMemberships,
        handleFiltersChange: this.handleFiltersChange,
        handleRoleChange: this.handleRoleChange
      })));
    }
  }]);

  return Team;
}(_react.Component);

exports.default = Team;